import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { normalize } from 'normalizr';
import { request } from 'utils';
import { FETCH_PRODUCTS_REQUEST, FETCH_PRODUCTS_FAILURE, FETCH_PRODUCTS_SUCCESS } from 'actionTypes';
import { PRODUCT_TYPE } from 'constants/filters';
import { getProductsIsFetching, getProductsIsLoaded, routerStateValuesConfig, getFormattedRouterUrlState, getFullPathname, getFormattedSearchParams } from 'selectors';
import { products as productsSchema } from 'schemas';

var fetchIds = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(productType, filters, props) {
    var _props$params;

    var url, _yield$request, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(process.env.APP_PRODUCTS_API_ROOT, "list?product_type=").concat(productType, "&active=1").concat(props != null && (_props$params = props.params) != null && _props$params.organizationSlug ? '&is_in_rvk_minfin=1' : '&is_in_minfin_catalog=1').concat(filters);
            _context.next = 3;
            return request(url);

          case 3:
            _yield$request = _context.sent;
            data = _yield$request.data;
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchIds(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var fetchProductsIds = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state, props) {
    var routerUrlState, searchParams, filters, ids;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            routerUrlState = getFormattedRouterUrlState(state, props);
            searchParams = getFormattedSearchParams(state, props);
            filters = Object.keys(routerStateValuesConfig).reduce(function (res, cur) {
              var _state$organizations, _state$organizations$, _searchParams$currenc;

              // Excluding request parameters from routerStateValuesConfig:
              if (routerStateValuesConfig[cur].type === 'checkbox') {
                return res;
              }

              var _routerStateValuesCon = routerStateValuesConfig[cur],
                  name = _routerStateValuesCon.name,
                  getProductsAPIFilters = _routerStateValuesCon.getProductsAPIFilters;
              var filter = getProductsAPIFilters(routerUrlState[name], {
                organization: state == null ? void 0 : (_state$organizations = state.organizations) == null ? void 0 : (_state$organizations$ = _state$organizations.organization[props.params.organizationSlug]) == null ? void 0 : _state$organizations$.data,
                page: props.params.page,
                clientType: props.params.clientType,
                currency: (_searchParams$currenc = searchParams.currency) == null ? void 0 : _searchParams$currenc[0],
                monthlyFee: searchParams.monthlyFee,
                activityType: searchParams.activityType
              });
              return "".concat(res).concat(filter ? "&".concat(filter) : '');
            }, '');
            _context2.next = 5;
            return fetchIds(PRODUCT_TYPE.rko, filters, props);

          case 5:
            ids = _context2.sent;
            return _context2.abrupt("return", ids);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchProductsIds(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getShouldFetchProducts = function getShouldFetchProducts(state, props) {
  var isFetching = getProductsIsFetching(state, props);
  var isLoaded = getProductsIsLoaded(state, props);
  return !isFetching && !isLoaded;
};

export var fetchProducts = function fetchProducts(props) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var state, url, produtsIds, fetchUrl, _yield$request2, data, _normalize, _normalize$entities$p, entities, _normalize$result, ids, _state, _url;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              state = getState();

              if (getShouldFetchProducts(state, props)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", true);

            case 4:
              url = getFullPathname(state, props);
              dispatch({
                type: FETCH_PRODUCTS_REQUEST,
                payload: {
                  url: url
                }
              });
              _context3.next = 8;
              return fetchProductsIds(state, props);

            case 8:
              produtsIds = _context3.sent;
              fetchUrl = "".concat(process.env.APP_PRODUCTS_API_ROOT, "data?locale=").concat(props.intl.locale, "&ids=").concat(produtsIds.join(','));
              _context3.next = 12;
              return request(fetchUrl);

            case 12:
              _yield$request2 = _context3.sent;
              data = _yield$request2.data;
              _normalize = normalize(data, productsSchema), _normalize$entities$p = _normalize.entities.products, entities = _normalize$entities$p === void 0 ? {} : _normalize$entities$p, _normalize$result = _normalize.result, ids = _normalize$result === void 0 ? [] : _normalize$result;
              return _context3.abrupt("return", dispatch({
                type: FETCH_PRODUCTS_SUCCESS,
                payload: {
                  url: url,
                  entities: Object.values(entities),
                  ids: ids
                }
              }));

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);
              _state = getState();
              _url = getFullPathname(_state, props);
              return _context3.abrupt("return", dispatch({
                type: FETCH_PRODUCTS_FAILURE,
                payload: {
                  url: _url
                }
              }));

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 18]]);
    }));

    return function (_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var fetchProductsByFilters = function fetchProductsByFilters(props) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var state, url, ids, fetchUrl, _yield$request3, data, _state2, _url2;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              state = getState();
              url = getFullPathname(state, props);
              dispatch({
                type: FETCH_PRODUCTS_REQUEST,
                payload: {
                  url: url,
                  isFilterFetching: true
                }
              });
              _context4.next = 6;
              return fetchProductsIds(state, props);

            case 6:
              ids = _context4.sent;
              fetchUrl = "".concat(process.env.APP_PRODUCTS_API_ROOT, "data?locale=").concat(props.intl.locale, "&ids=").concat(ids.join(','));
              _context4.next = 10;
              return request(fetchUrl);

            case 10:
              _yield$request3 = _context4.sent;
              data = _yield$request3.data;
              return _context4.abrupt("return", dispatch({
                type: FETCH_PRODUCTS_SUCCESS,
                payload: {
                  url: url,
                  entities: data,
                  ids: ids || [],
                  isFilterFetching: false
                }
              }));

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](0);
              _state2 = getState();
              _url2 = getFullPathname(_state2, props);
              return _context4.abrupt("return", dispatch({
                type: FETCH_PRODUCTS_FAILURE,
                payload: {
                  url: _url2
                }
              }));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 15]]);
    }));

    return function (_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
};